import { SpeakingSlotDto } from 'api/planning';

export const applyCapacityToSlots = (slots: SpeakingSlotDto[], plannedCapacity: number) =>
  slots.map((slot) => {
    const bookedSeats = slot.plannedCapacity - slot.availableCapacity;
    return {
      ...slot,
      plannedCapacity,
      availableCapacity: Math.max(0, plannedCapacity - bookedSeats),
    };
  });
